export const COUNTRY_AND_STATES_URL = 'https://sguniverse-2.s3-us-west-1.amazonaws.com/data/countries.json';

export const PLAYER_REGISTARTION = (baseUrl: string, tenantCode: string) => `${baseUrl}${tenantCode}/cms/players`;

export const EXISTING_PLAYER_REGISTARTION=(baseUrl:string,tenantCode:string,playerId) => `${baseUrl}${tenantCode}/totp/generate?playerId=${playerId}`

export const   VALIDATE_TOTP =(baseUrl: string, tenantCode: string) => `${baseUrl}${tenantCode}/totp/validate`;

export const   VALIDATE_PLAYER_PIN = (baseUrl:string,tenantCode:string,playerId) => `${baseUrl}${tenantCode}/cms/players/${playerId}/pin/validate`

export const GET_COGNITO_DETAILS = (baseUrl: string, tenantCode: string) => `${baseUrl}${tenantCode}/patroninfo/getCognitoDetails`;

export const GET_COGNITO_USER_INFO = (baseUrl: string, tenantCode: string, searchValue: string) => `${baseUrl}${tenantCode}/patroninfo/getCognitoUserInfo?searchValue=${encodeURIComponent(searchValue)}`;

export const VALIDATE_USER_INFO = (baseUrl: string, tenantCode: string) => `${baseUrl}${tenantCode}/patroninfo/validateUserInfo`;

export const ACCOUNT_UNLOCK_GENERATE_OTP = (baseUrl: string, tenantCode: string, identifier: string, isEmail: boolean) => `${baseUrl}${tenantCode}/accountunlock/generate?${isEmail ? 'email' : 'accountNumber'}=${encodeURIComponent(identifier)}`;

export const ACCOUNT_UNLOCK_VALIDATE_OTP = (baseUrl: string, tenantCode: string, identifier: string, isEmail: boolean) => `${baseUrl}${tenantCode}/accountunlock/validate?${isEmail ? 'email' : 'accountNumber'}=${encodeURIComponent(identifier)}`;

export const MFA_RESET_GENERATE_OTP = (baseUrl: string, tenantCode: string, identifier: string, isEmail: boolean) => `${baseUrl}${tenantCode}/mfareset/generate?${isEmail ? 'email' : 'accountNumber'}=${encodeURIComponent(identifier)}`;

export const MFA_RESET_VALIDATE_OTP = (baseUrl: string, tenantCode: string, identifier: string, isEmail: boolean) => `${baseUrl}${tenantCode}/mfareset/validate?${isEmail ? 'email' : 'accountNumber'}=${encodeURIComponent(identifier)}`;

export const UPDATE_MIGRATION_STATUS = (baseUrl: string, tenantCode: string) => `${baseUrl}${tenantCode}/patroninfo/updateMigrationStatus`;

